
// Swiper logic is now centralized in swiper-init.js

// Dropdown functionality
document.querySelectorAll('.dropdown').forEach(item => {
    // Open on hover
    item.addEventListener('mouseenter', () => {
        const dropdownMenu = item.querySelector('.dropdown-menu');
        if (dropdownMenu) {
            dropdownMenu.classList.add('show');
        }
    });

    // Close when leaving
    item.addEventListener('mouseleave', () => {
        const dropdownMenu = item.querySelector('.dropdown-menu');
        if (dropdownMenu) {
            dropdownMenu.classList.remove('show');
        }
    });
});

// For nested dropdowns (multi-level)
document.querySelectorAll('.dropdown-menu .dropdown').forEach(item => {
    item.addEventListener('mouseenter', () => {
        item.querySelector('.dropdown-menu').classList.add('show');
    });
    item.addEventListener('mouseleave', () => {
        item.querySelector('.dropdown-menu').classList.remove('show');
    });
});

// Show/hide jump link based on scroll position
window.addEventListener('scroll', function() {
    const jumpLink = document.getElementById('jumpLink');
    if (window.pageYOffset > 300) {
        jumpLink.classList.add('visible');
    } else {
        jumpLink.classList.remove('visible');
    }
});

// Customizer JS for social links
if (typeof wp !== 'undefined' && wp.customize) {
    wp.customize.bind('ready', function() {
        // Add new social link
        $('.add-social-link').on('click', function() {
            var $list = $(this).siblings('.social-links-list');
            var index = $list.children().length;

            var html = '<li class="social-link-row">' +
                '<select class="social-platform" name="' + $list.attr('id') + '[' + index + '][platform]">' +
                '<option value="facebook">Facebook</option>' +
                '<option value="yelp">Yelp</option>' +
                '<option value="phone">Phone</option>' +
                '</select>' +
                '<input type="text" class="social-url" placeholder="URL" name="' + $list.attr('id') + '[' + index + '][url]">' +
                '<input type="text" class="social-text" placeholder="Link Text" name="' + $list.attr('id') + '[' + index + '][text]">' +
                '<a href="#" class="remove-social-link">Remove</a>' +
                '</li>';

            $list.append(html);
            updateSocialLinksValue($list);
        });

        // Remove social link
        $(document).on('click', '.remove-social-link', function(e) {
            e.preventDefault();
            $(this).parent().remove();
            updateSocialLinksValue($(this).parents('.social-links-list'));
        });

        // Update hidden input value
        function updateSocialLinksValue($list) {
            var data = [];
            $list.find('.social-link-row').each(function(i) {
                data.push({
                    platform: $(this).find('.social-platform').val(),
                    url: $(this).find('.social-url').val(),
                    text: $(this).find('.social-text').val()
                });
            });

            $list.siblings('input[type="hidden"]').val(JSON.stringify(data)).trigger('change');
        }

        // Handle changes to inputs
        $(document).on('change', '.social-platform, .social-url, .social-text', function() {
            updateSocialLinksValue($(this).parents('.social-links-list'));
        });
    });

}

// Announcement Bar Logic
document.addEventListener('DOMContentLoaded', function() {
    const announcementBar = document.getElementById('pu-announcement-bar');
    const closeBtn = document.getElementById('close-announcement');

    if (announcementBar && closeBtn) {
        // Check if closed in this session
        if (sessionStorage.getItem('pu_announcement_closed') === 'true') {
            announcementBar.style.display = 'none';
        } else {
            // Show with delay for transition
            setTimeout(() => {
                announcementBar.classList.add('show');
            }, 500);
        }

        closeBtn.addEventListener('click', () => {
            announcementBar.classList.remove('show');
            sessionStorage.setItem('pu_announcement_closed', 'true');
            
            // Remove from DOM after transition
            setTimeout(() => {
                announcementBar.style.display = 'none';
            }, 500);
        });
    }
});
// Immersive Search Overlay Logic
document.addEventListener('DOMContentLoaded', function() {
    const trigger = document.getElementById('triggerSearch');
    const overlay = document.getElementById('searchOverlay');
    const close = document.getElementById('closeSearch');
    const input = document.getElementById('searchInput');

    if (trigger && overlay && close) {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            overlay.classList.add('active');
            setTimeout(() => input.focus(), 300);
            document.body.style.overflow = 'hidden';
        });

        const closeSearch = () => {
            overlay.classList.remove('active');
            document.body.style.overflow = '';
        };

        close.addEventListener('click', closeSearch);
        
        // Close on Escape
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && overlay.classList.contains('active')) {
                closeSearch();
            }
        });

        // Close on click outside container
        overlay.addEventListener('click', (e) => {
            if (e.target === overlay) closeSearch();
        });
    }
});

// Mobile FAB Visibility
window.addEventListener('scroll', function() {
    const fab = document.querySelector('.mobile-cta-fab');
    if (!fab) return;

    if (window.pageYOffset > 500) {
        fab.classList.add('visible');
    } else {
        fab.classList.remove('visible');
    }
});

// Hero Premium 2026 - Mouse Tracking & Parallax
document.addEventListener('DOMContentLoaded', function() {
    const hero = document.querySelector('.hero-premium-2026');
    const glow = document.getElementById('heroMouseGlow');
    const imageWrapper = document.querySelector('.hero-image-wrapper');
    
    if (hero && (glow || imageWrapper)) {
        hero.addEventListener('mousemove', (e) => {
            const rect = hero.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            
            // Mouse Glow Position
            if (glow) {
                requestAnimationFrame(() => {
                    glow.style.left = x + 'px';
                    glow.style.top = y + 'px';
                });
            }

            // Image Parallax Tilt
            if (imageWrapper) {
                const centerX = rect.width / 2;
                const centerY = rect.height / 2;
                const moveX = (x - centerX) / 50;
                const moveY = (y - centerY) / 50;

                requestAnimationFrame(() => {
                    imageWrapper.style.transform = `perspective(1000px) rotateY(${moveX}deg) rotateX(${-moveY}deg)`;
                });
            }
        });

        // Reset tilt on mouse leave
        hero.addEventListener('mouseleave', () => {
            if (imageWrapper) {
                imageWrapper.style.transition = 'transform 0.5s ease';
                imageWrapper.style.transform = 'perspective(1000px) rotateY(0deg) rotateX(0deg)';
                setTimeout(() => {
                    imageWrapper.style.transition = '';
                }, 500);
            }
        });
    }
});
